module.exports = __webpack_public_path__ + "static/about-content-image-5-a8f8f342dbc0e9e5af231bd02de2f89c.jpg";